import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    select: {
      display: "flex",
      justifyContent: "center",
      width: 300
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    },
    field: {
      display: "flex",
      justifyContent: "center",
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(2)
    },
    orderItemField: {
      display: "flex",
      justifyContent: "center",
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2)
    },
    scanner: {
      "& > div": {
        flex: 1
      }
    },
    searchField: {
      display: "flex",
      justifyContent: "center",
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3)
    }
  })
);
